/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
// import { useUrlGenerator } from '@micromag/core/contexts';

import Footer from '../../../partials/Footer';
import { getFormatValues } from '../../../../lib/utils';

import styles from '../../../../../styles/guest/sections/content/contact.module.scss';
import { useContactForm } from '../../../../hooks';

const propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    active: false,
    className: null,
};

const Contact = ({ active, className }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [organisation, setOrganisation] = useState('');
    const [role, setRole] = useState('');
    const [message, setMessage] = useState('');
    const { send, sending } = useContactForm();

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const onSubmit = useCallback(
        (e) => {
            e.preventDefault();
            setLoading(true);
            setSuccess(false);
            if (!sending) {
                send({ name, email, organisation, role, message })
                    .then((res) => {
                        if (res.success) {
                            setSuccess(true);
                        }
                    })
                    .catch(() => {
                        setSuccess(false);
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        },
        [name, email, organisation, role, message, send, sending],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.active]: active,
                    [styles.loading]: loading,
                    [styles.success]: success,
                },
            ])}
        >
            <div className={styles.content}>
                <div className={styles.text}>
                    <h2>
                        <FormattedMessage
                            defaultMessage="Want to know more?"
                            description="Guest content - contact title"
                            values={getFormatValues()}
                        />
                    </h2>
                    <p>
                        <FormattedMessage
                            defaultMessage="Would you like to know about our annual rates or simply share your comments with us?{break}<strong>We’re here for you.</strong>"
                            description="Guest content - contact description"
                            values={getFormatValues()}
                        />
                    </p>
                </div>
                <div className={styles.formContainer}>
                    {success !== true ? (
                        <form className={styles.form} onSubmit={onSubmit} disabled={loading}>
                            <div className={styles.fields}>
                                <label className={styles.formGroup}>
                                    <div className={styles.label}>
                                        <FormattedMessage
                                            defaultMessage="Name"
                                            description="Name field label"
                                        />
                                    </div>
                                    <input
                                        name="name"
                                        type="text"
                                        required
                                        value={name}
                                        onChange={(e) => {
                                            setName(e.target.value);
                                        }}
                                    />
                                </label>
                                <label className={styles.formGroup}>
                                    <div className={styles.label}>
                                        <FormattedMessage
                                            defaultMessage="Email"
                                            description="Email field label"
                                            values={getFormatValues()}
                                        />
                                    </div>
                                    <input
                                        name="email"
                                        type="email"
                                        required
                                        value={email}
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                        }}
                                    />
                                </label>
                                <label className={styles.formGroup}>
                                    <div className={styles.label}>
                                        <FormattedMessage
                                            defaultMessage="Organisation"
                                            description="Organisation field label"
                                            values={getFormatValues()}
                                        />
                                    </div>
                                    <input
                                        name="organisation"
                                        type="text"
                                        value={organisation}
                                        onChange={(e) => {
                                            setOrganisation(e.target.value);
                                        }}
                                    />
                                </label>
                                <label className={styles.formGroup}>
                                    <div className={styles.label}>
                                        <FormattedMessage
                                            defaultMessage="Role"
                                            description="Role field label"
                                            values={getFormatValues()}
                                        />
                                    </div>
                                    <input
                                        name="role"
                                        type="text"
                                        value={role}
                                        onChange={(e) => {
                                            setRole(e.target.value);
                                        }}
                                    />
                                </label>
                                <label className={classNames([styles.formGroup, styles.fullWidth])}>
                                    <div className={styles.label}>
                                        <FormattedMessage
                                            defaultMessage="Message"
                                            description="Message field label"
                                            values={getFormatValues()}
                                        />
                                    </div>
                                    <textarea
                                        name="message"
                                        required
                                        onChange={(e) => {
                                            setMessage(e.target.value);
                                        }}
                                        rows={8}
                                        value={message}
                                    />
                                </label>
                            </div>
                            <button className={styles.submit} type="submit" aria-label="submit">
                                {success ? (
                                    <FormattedMessage
                                        defaultMessage="Sent"
                                        description="Sent form feedback"
                                        values={getFormatValues()}
                                    />
                                ) : (
                                    <FormattedMessage
                                        defaultMessage="Send"
                                        description="Submit form label"
                                        values={getFormatValues()}
                                    />
                                )}
                            </button>
                        </form>
                    ) : (
                        <div className={styles.success}>
                            <h3>
                                <FormattedMessage
                                    defaultMessage="Thanks!"
                                    description="Thanks form feedback"
                                    values={getFormatValues()}
                                />
                            </h3>
                        </div>
                    )}
                </div>
            </div>
            <Footer className={styles.sectionFooter} />
        </div>
    );
};

Contact.propTypes = propTypes;
Contact.defaultProps = defaultProps;

export default Contact;
